import styled from '@emotion/styled';
import { Button, Stack } from '@ui-components/neo.tax';

export const StackStyled = styled(Stack)({
  marginTop: '1.5rem',
});

export const ApplyRDPercentageToExpensesButton = styled(Button)({
  minWidth: 50,
  margin: 0,
});

const ANIMATION_DURATION = '0.3s';

export const SelectAllBanner = styled.div<{ isVisible: boolean }>(({ isVisible }) => ({
  maxHeight: isVisible ? 120 : 0,
  opacity: isVisible ? 1 : 0,
  overflow: 'hidden',
  transition: `max-height ${ANIMATION_DURATION} ease, opacity ${ANIMATION_DURATION} ease, padding ${ANIMATION_DURATION} ease`,
  padding: isVisible ? '8px 0' : '0',
}));
